// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  background-color: #171c1f;
  top: 0;
  right: 20px;
  width: 100%;
  z-index: 10;
}
.header .logo {
  cursor: pointer;
  text-decoration: none;
}
.header .logo img {
  width: 140px;
  height: 70px;
}
.header h4 {
  font-size: 20px;
  line-height: 50px;
  font-weight: 600;
  padding-left: 40px;
  color: #ffffff;
  margin-bottom: 0;
}
.header .custom-nav {
  position: absolute;
  top: 70px;
  background-color: #171c1f;
  padding-left: 50px;
}
@media (min-width: 992px) {
  .header:after {
    content: '';
    display: block;
    background-color: #f8f8f8;
    width: 100%;
    height: 1px;
    z-index: 10;
  }
  .header .custom-nav {
    right: 40px;
    left: auto;
    top: 54px;
    background: transparent;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Header/header.scss","webpack://./src/components/Header/header.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,yBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;ACCF;ADCE;EACE,eAAA;EACA,qBAAA;ACCJ;ADCI;EACE,YAAA;EACA,YAAA;ACCN;ADGE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;ACDJ;ADIE;EACE,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;ACFJ;ADKE;EACE;IACE,WAAA;IACA,cAAA;IACA,yBAAA;IACA,WAAA;IACA,WAAA;IAEA,WAAA;ECJJ;EDOE;IACE,WAAA;IACA,UAAA;IACA,SAAA;IACA,uBAAA;ECLJ;AACF","sourcesContent":[".header {\n  position: fixed;\n  background-color: #171c1f;\n  top: 0;\n  right: 20px;\n  width: 100%;\n  z-index: 10;\n\n  .logo {\n    cursor: pointer;\n    text-decoration: none;\n\n    img {\n      width: 140px;\n      height: 70px;\n    }\n  }\n\n  h4 {\n    font-size: 20px;\n    line-height: 50px;\n    font-weight: 600;\n    padding-left: 40px;\n    color: #ffffff;\n    margin-bottom: 0;\n  }\n\n  .custom-nav {\n    position: absolute;\n    top: 70px;\n    background-color: #171c1f;\n    padding-left: 50px;\n  }\n\n  @media (min-width: 992px) {\n    &:after {\n      content: '';\n      display: block;\n      background-color: #f8f8f8;\n      width: 100%;\n      height: 1px;\n      // margin-top: -15px;\n      z-index: 10;\n    }\n\n    .custom-nav {\n      right: 40px;\n      left: auto;\n      top: 54px;\n      background: transparent;\n    }\n  }\n}\n",".header {\n  position: fixed;\n  background-color: #171c1f;\n  top: 0;\n  right: 20px;\n  width: 100%;\n  z-index: 10;\n}\n.header .logo {\n  cursor: pointer;\n  text-decoration: none;\n}\n.header .logo img {\n  width: 140px;\n  height: 70px;\n}\n.header h4 {\n  font-size: 20px;\n  line-height: 50px;\n  font-weight: 600;\n  padding-left: 40px;\n  color: #ffffff;\n  margin-bottom: 0;\n}\n.header .custom-nav {\n  position: absolute;\n  top: 70px;\n  background-color: #171c1f;\n  padding-left: 50px;\n}\n@media (min-width: 992px) {\n  .header:after {\n    content: '';\n    display: block;\n    background-color: #f8f8f8;\n    width: 100%;\n    height: 1px;\n    z-index: 10;\n  }\n  .header .custom-nav {\n    right: 40px;\n    left: auto;\n    top: 54px;\n    background: transparent;\n  }\n} /*# sourceMappingURL=header.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
